'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/ExitSlide.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExitSlide = function ExitSlide(_ref) {
  var url = _ref.url;
  return _react2.default.createElement(
    _reactIntl.FormattedMessage,
    { id: 'view_all' },
    function (message) {
      return _react2.default.createElement(
        'a',
        { className: 'cp-exit-slide', href: url },
        _react2.default.createElement(
          'div',
          { className: 'centered' },
          _react2.default.createElement(
            'span',
            null,
            message,
            _react2.default.createElement(_baseIcons.Chevron.Right, { className: 'carousel-heading' })
          )
        )
      );
    }
  );
};

ExitSlide.propTypes = {
  url: _react.PropTypes.string.isRequired
};

exports.default = ExitSlide;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/carousel-base/lib/components/ExitSlide.component.js
// module id = 1400
// module chunks = 1